import ArticleDetails from '../../../sections/ArticleDetails';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import { useRootSelector } from '../../../../store/hooks';
import {
  selectSiteArticleDetailsData,
  selectSiteArticleDetailsMeta,
} from '../../../../store/features/siteArticles/siteArticleDetails';
import { selectPageConfig } from '../../../../store/features/pageConfig';
import { generateDomainUrl } from '../../../../helpers/generateDomainUrl';

import styles from './ArticleDetailsView.module.scss';

export default function ArticleDetailsView() {
  const articleData = useRootSelector(selectSiteArticleDetailsData);
  const articleMeta = useRootSelector(selectSiteArticleDetailsMeta);
  const { tenantsConfig } = useRootSelector(selectPageConfig);

  const helmet = {
    title: articleMeta.title,
    description: articleData.summary,
    canonical: generateDomainUrl({
      domains: tenantsConfig,
      tenant: 'INFORMACONNECT',
      domain: 'INFORMACONNECT',
      path: articleData.articlePath,
    }),
  };

  return (
    // @ts-ignore
    <SiteLayout helmet={helmet}>
      <div className={styles.wrapper}>
        <ArticleDetails />
      </div>
    </SiteLayout>
  );
}
